import createRestClient from '../restClient';

const restClient = createRestClient();

const getUserTeamRole = () => restClient.get('user/role');

export default {
  getUserTeamRole,
};
